const config = {
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL || 'http://dam.test/api',
};

export default config;